import BlackBg from "../common/PopUp/BlackBg";
import PopUpBody from "../common/PopUp/PopUpBody";
import PopUpContainer from "../common/PopUp/PopUpContainer";
import PopUpHeader from "../common/PopUp/PopUpHeader";
import ButtonGroup from "../common/PopUp/ButtonGroup";

import { useState } from "react";
import { fetchWithToken } from "../../functions/fetch";
import { onChange } from "../../functions/input";
import uniqid from "uniqid";
import { useUpdateAnnouncement } from "../../contexts/updateAnnouncementContext";

// can be used for both create and update by prop
const AnnouncementPopUp = ({
  setShowPopUp,
  method,
  curAnnouncement,
  setUnfilteredAnnouncements,
}) => {
  const itemName = "公告";
  const updating = method === "PUT";
  const typeOptions = ["生活公約｜Rule", "設備保養｜Facility", "其他｜Other"];
  const defaultType = "其他｜Other";

  const [title, setTitle] = useState(updating ? curAnnouncement.title : "");
  const [text, setText] = useState(updating ? curAnnouncement.text : "");
  const [top, setTop] = useState(updating ? curAnnouncement.top : false);
  const [type, setType] = useState(
    updating ? curAnnouncement.type : defaultType,
  );
  const [errors, setErrors] = useState([]);

  const { setUpdateAnnouncement } = useUpdateAnnouncement();

  // it's using POST currently
  const update = async () => {
    if (method === "PUT") {
      const formBody = {
        text,
        top,
        title,
        type,
      };

      const res = await fetchWithToken(
        "PUT",
        `${process.env.REACT_APP_BACKEND_HOST}/api/announcement/${curAnnouncement._id}`,
        formBody,
      );

      if (res.status === 200) {
        const newAnnouncement = curAnnouncement;
        newAnnouncement.top = top;

        // update local announcement
        setUpdateAnnouncement(true);
        setShowPopUp(false);
      } else {
        setErrors(res.errors);
      }
    } else if (method === "POST") {
      const formBody = {
        text,
        top,
        title,
        type,
      };

      const res = await fetchWithToken(
        "POST",
        `${process.env.REACT_APP_BACKEND_HOST}/api/announcement`,
        formBody,
      );
      if (res.status === 200) {
        // tell page to refetch
        setUpdateAnnouncement(true);
        setShowPopUp(false);
      } else {
        setErrors(res.errors);
      }
    }
  };

  const onChangeTop = (event) => {
    setTop(event.target.checked);
  };

  const cancel = () => {
    setShowPopUp(false);
  };

  return (
    <>
      <BlackBg cancel={cancel} />
      <PopUpContainer>
        <PopUpHeader itemName={itemName} />
        <PopUpBody>
          <label htmlFor="title">公告標題</label>
          <input
            type="text"
            name=""
            id="title"
            className="bg-input-gray px-1"
            value={title}
            onChange={(event) =>
              onChange(event, setTitle, true, null, "標題", errors, setErrors)
            }
          />
          <div className="col-span-2 flex gap-x-2 items-center justify-end">
            <input
              type="checkbox"
              className="w-4 h-4"
              name=""
              id="top"
              checked={top}
              onChange={onChangeTop}
            />
            <label htmlFor="top">置頂</label>
          </div>
          <label htmlFor="type">公告類別</label>
          <select
            className="bg-input-gray"
            value={type}
            onChange={(event) => setType(event.target.value)}
          >
            {typeOptions.map((text) => (
              <option value={text} key={uniqid()}>
                {text}
              </option>
            ))}
          </select>
          <div className="col-span-2" />{" "}
          {/* placeholder for two column, no function */}
          <label htmlFor="text" className="justify-self-end self-start">
            公告內容
          </label>
          <textarea
            id="text"
            className="bg-input-gray col-span-3 px-1"
            value={text}
            onChange={(event) =>
              onChange(event, setText, true, null, "內容", errors, setErrors)
            }
          />
          <ButtonGroup
            errors={errors}
            cancelFunction={cancel}
            canDelete={false}
            updateFunction={update}
          />
        </PopUpBody>
      </PopUpContainer>
    </>
  );
};

export default AnnouncementPopUp;
